import { Component, Input, OnInit, forwardRef, Inject } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                  from '@uirouter/core';

import { CompanyService }          from '../companies/company.service';
import { CompanySettingsModel }    from '../companies/models/company.settings';
import { CustomerPortalService }   from './customer-portal.service';
import { MessagesService }         from '../messages/messages.service';

@Component({
  selector   : 'wor-customer-portal-settings',
  template: require('./customer-portal.settings.component.html')
})
export class CustomerPortalSettingsComponent implements OnInit {
  @Input() settings: CompanySettingsModel;

  hasIntegration: boolean;

  constructor (
    @Inject(forwardRef(() => CompanyService))
    private companyService         : CompanyService,
    @Inject(forwardRef(() => CustomerPortalService)) private customerPortalService  : CustomerPortalService,
    @Inject(forwardRef(() => MessagesService)) private messagesService        : MessagesService,
    private router                 : UIRouter,
    private translateService       : TranslateService
  ) {}

  ngOnInit (): void {
    this.hasIntegration = this.companyService.hasIntegration('customer-portal');
  }

  activate (): void {
    this.customerPortalService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.TITLE')
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  deactivate (): void {
    this.customerPortalService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.TITLE')
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }
}
